import * as actionTypes from '../constants/searchInfoConstants'

// 图书检索
export function bookSearch(data) {
    // console.log("BOOK_SEARCH");
    return {
        type: actionTypes.BOOK_SEARCH,
        data
    }
}

// 高级检索
export function advancedSearch(data) {
    // console.log("ADVANCED_SEARCH");

    return {
        type: actionTypes.ADVANCED_SEARCH,
        data
    }
}

// 查询条件 状态
export function searchCondition(data) {
    // console.log("SEARCH_CONDITION");

    return {
        type: actionTypes.SEARCH_CONDITION,
        data
    }
}

// 上一页
export function previousPage(data) {
    // console.log("PREVIOUS_PAGE");

    return {
        type: actionTypes.PREVIOUS_PAGE,
        data
    }
}

// 下一页
export function nextPage(data) {
    return {
        type: actionTypes.NEXT_PAGE,
        data
    }
}

// 图书地址展示
export function bookAddress(data) {
    // console.log("BOOK_ADDRESS");

    return {
        type: actionTypes.BOOK_ADDRESS,
        data
    }
}

// 图书地址展示 去除
export function undoBg(data) {
    // console.log("UNDO_BG");

    return {
        type: actionTypes.UNDO_BG,
        data
    }
}


// WEBPACK FOOTER //
// ./src/actions/searchInfoActions.js